import router from '../router/index-web.js';

export default function logUserOutWeb(store) {
  if (store === undefined) {
    store = this.$store;
  }

  localStorage.removeItem('backgroundImage');
  localStorage.removeItem('specialDates');
  localStorage.removeItem("firebaseToken");
  store.commit('userData', null);
  store.commit('bedroomLanguage', {});
  router.push({name: 'position-categories'});
}

